import { formatImgUrl } from 'constants/configs/theme.config'
import { STYLED_VARIABLES } from 'constants/styledVariables'

import React from 'react'

import styled from 'styled-components'

import { getContentTypesUploadSelector } from "../../common/selectors"
import { getUiTheme } from "../../user/selectors"
import { THEME } from "../../user/userSlice"
import { FAMILY_ONBOARDING_CLASSES } from "../../../constants/familyOnboarding"

interface EmptyTimelinePlaceholderProps {
    className?: string,
    texts: {
        title: string,
        description: string,
        uploadBtn: string
    },
    onUploadFiles: (files: FileList) => void,
  withoutUploading?: boolean
}

export const EmptyTimelinePlaceholder: React.FC<EmptyTimelinePlaceholderProps> = ({
  className = '',
  texts,
  onUploadFiles,
  withoutUploading
}) => {
  const handleUploadFiles = (e) => {
    onUploadFiles(e.target.files)
  }

  const contentTypesUpload = getContentTypesUploadSelector()

  const theme = getUiTheme()

  return (
    <EmptyAlbumPlaceholderBox
      className={className}
    >
      {theme === THEME.LIGHT ? <ContainerImg src={formatImgUrl("/assets/placeholders-images/no-photos.svg")} /> :
        <ContainerImg src={formatImgUrl("/assets/placeholders-images-black/no-photos.svg")} />}

      <EmptyTitle>
        {texts.title}
      </EmptyTitle>

      <EmptyText>
        {texts.description}
      </EmptyText>

      {!withoutUploading && (
        <StyledSecondaryButton
          htmlFor="timeline-upload"
          className={FAMILY_ONBOARDING_CLASSES.MOBILE_STEP_2}
        >
          {texts.uploadBtn}

          <HiddenFilesInput
            id="timeline-upload"
            onChange={handleUploadFiles}
            type="file"
            multiple
            accept={contentTypesUpload}
          />
        </StyledSecondaryButton>
      )}

      {
        !!withoutUploading && (
          <StyledSecondaryButton onClick={handleUploadFiles}>
            {texts.uploadBtn}
          </StyledSecondaryButton>
        )
      }
    </EmptyAlbumPlaceholderBox>
  )
}

const EmptyAlbumPlaceholderBox = styled.div`
  display: flex;
  flex-flow: column;
  margin-bottom: 0;
  flex-grow: 1;
  justify-content: center;
  align-items: center;
  width: 100%;
  min-height: calc(100vh - 16rem);
`

const ContainerImg = styled.img`
  width: 292px;
  height: 186px;
  pointer-events: none;
`

const EmptyTitle = styled.h2`
  margin-top: 40px;
  font-weight: 400;
  font-size: 24px;
  line-height: 37px;
  display: flex;
  align-items: center;
  text-align: center;
  color: var(--text-primary);
  max-width: 280px;

  @media (min-width: ${STYLED_VARIABLES.BREAKPOINTS.PHONE_100}) {
    line-height: 32px;
    max-width: unset;
    font-weight: 500;
  }
`

const EmptyText = styled.p`
  margin-top: 20px;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  display: none;
  align-items: center;
  text-align: center;
  color: var(--text-primary);

  @media (min-width: ${STYLED_VARIABLES.BREAKPOINTS.PHONE_100}) {
    display: flex;
  }
`

const StyledSecondaryButton = styled.label`
  margin-top: 32px;
  background: transparent;
  border: 1px solid var(--button-secondary-default-border);
  border-radius: 4px;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  display: flex;
  align-items: center;
  text-align: center;
  color: var(--text-primary);
  padding: 8px 24px;
  cursor: pointer;

  &:hover {
    background-color: var(--button-secondary-hover)
  }

  @media (min-width: ${STYLED_VARIABLES.BREAKPOINTS.PHONE_100}) {
    margin-top: 40px;
  }
`

const HiddenFilesInput = styled.input`
  display: none;
`
